module.exports = __webpack_public_path__ + "img/not-found-1360.890d380edb7cb1de15063b2e3654e4cc.png";